const config = {
    settings: {
        currency: {
            code: "EUR",
            symbol: "€",
        },
    },
};

export default config;
